const { QA, GLOBAL } = require('../constant');
const config = require('./config');

module.exports = {
  ...config,
  i18nPath: `${process.env.i18nPath}/i18n/api/v1/dev`,
  buildEnv: QA,
  site: GLOBAL,
};
